import * as React from 'react';
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';

const TABLE_HEAD = (
    <tr>
        <th scope="col">N° Orden</th>
        <th scope="col">Tipo</th>
        <th scope="col">Estado</th>
        <th scope="col">Fecha</th>
        <th scope="col">Importe</th>
        <th scope="col">Comisión Neta</th>
        <th scope="col">Comisión Total</th>
        <th scope="col">Total</th>
    </tr>
);

export default class OrdenesDeLiquidaciones extends React.Component {
    render = () => {
        const ordenes = this.props.ordenes ?? [];

        return (
            <LiquidacionDetalleTabla
                title="Órdenes"
                data={ordenes}
                isLoading={this.props.isLoading}
                loadingMessage="Cargando ordenes de la liquidacion..."
                emptyMessage="No hay órdenes para esta liquidación"
                tableHead={TABLE_HEAD}
                renderRow={(orden, i, globalIndex) => (
                    <tr key={orden.idOrden ?? globalIndex} className="hover-background-color">
                        <td><small>{orden.idOrden}</small></td>
                        <td><small>{orden.tipoPublicacion}</small></td>
                        <td><small>{orden.descripcionEstado}</small></td>
                        <td><small>{orden.fechaOrdenMostrar}</small></td>
                        <td><small>${orden.importeOrden}</small></td>
                        <td><small>${orden.importeComisionNeta}</small></td>
                        <td><small>${orden.importeComisionTotal}</small></td>
                        <td><small>${orden.totalOrden}</small></td>
                    </tr>
                )}
            />
        );
    };
}
